import { render, staticRenderFns } from "./user-person-table.vue?vue&type=template&id=a668e1e4&"
import script from "./user-person-table.vue?vue&type=script&lang=ts&"
export * from "./user-person-table.vue?vue&type=script&lang=ts&"
import style0 from "./user-person-table.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports